<a mat-button
   class="phone-button"
   href="tel:{{ this.clearSignSupportNumber }}"
   tabIndex="0"
   data-testid="header-support-phoneNumber"
   rel="noopener"
   title="Support Phone Number">
  <span>{{ showPhoneNumber ? this.clearSignSupportNumber : "" }}
    <img src="assets/icons/phone_in_talk-icon.svg" alt="Phone Icon">
  </span>
</a>
